import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-blocked-view',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './blocked-view.component.html',
  styleUrl: './blocked-view.component.scss'
})
export class BlockedViewComponent { 
}